interface IInputTestIds {
  labelTestId: string;
  messageTestId: string;
  validationTestId: string;
  wrapperTestId: string;
  dropdownTestId: string;
  flagTestId: string;
  countryCodeTestId: string;
  selectWrapperTestId: string;
}

export default function useTestIds(testId?: string): Partial<IInputTestIds> {
  if (!testId) {
    return {};
  }
  return {
    countryCodeTestId: testId.concat('-country-code'),
    dropdownTestId: testId.concat('-dropdown'),
    labelTestId: testId.concat('-label'),
    messageTestId: testId.concat('-message'),
    validationTestId: testId.concat('-validation'),
    wrapperTestId: testId.concat('-wrapper')
  };
}
